import { AppBar, Tab, Tabs } from "@mui/material";
import { TabPanel } from "components/TabPanel";
import TabToolbarPlaceholder from "components/TabToolbarPlaceholder";
import { ChecklistTab } from "components/job/checklist/ChecklistTab";
import { FilesTab } from "components/job/files/FilesTab";
import { NotesTab } from "components/job/notes/NotesTab";
import { RequestedPartsTab } from "components/job/parts/RequestedPartsTab";
import { VisitsTab } from "components/job/visit/VisitsTab";
import { isEmpty } from "helpers";
import { PlannerJobDetailTab } from "pages/planner/plannerDetails/tabs/PlannerJobDetailTab";
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useAppDispatch, useAppSelector } from "store";
import { selectPageSelectedJob } from "store/root.store";
import { setAppBar } from "store/slices/menu.store";

export const PlannerJobDetails: FC = () => {
  const job = useAppSelector(selectPageSelectedJob);
  const { workNotes, files, visits } = job;
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const [tabValue, setTabValue] = useState("details");

  useEffect(() => {
    dispatch(
      setAppBar({
        title: job?.externalId ?? "",
        goingBack: true,
      })
    );
  }, [dispatch, job]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          mt: 7,
          backgroundColor: `primary.main`,
        }}
      >
        <Tabs
          scrollButtons
          value={tabValue}
          onChange={(_, newValue: string) => {
            setTabValue(newValue);
          }}
          variant="scrollable"
          textColor="inherit"
        >
          <Tab label={intl.formatMessage({ id: "general.details" })} value="details" />
          {!isEmpty(job.checklists) && (
            <Tab label={intl.formatMessage({ id: "job.checklists" })} value="checklists" />
          )}
          {!isEmpty(files) && (
            <Tab label={intl.formatMessage({ id: "general.files" })} value="files" />
          )}
          {!isEmpty(workNotes) && (
            <Tab label={intl.formatMessage({ id: "job.notes" })} value="notes" />
          )}
          {!isEmpty(visits) && (
            <Tab label={intl.formatMessage({ id: "general.visits" })} value="visits" />
          )}
          {!isEmpty(job.preOrderedParts) && (
            <Tab label={intl.formatMessage({ id: "part.requestedParts" })} value="requestedParts" />
          )}
        </Tabs>
      </AppBar>
      <TabToolbarPlaceholder />

      <TabPanel index="details" value={tabValue}>
        <PlannerJobDetailTab />
      </TabPanel>
      <TabPanel index="files" value={tabValue}>
        <FilesTab />
      </TabPanel>
      <TabPanel index="notes" value={tabValue}>
        <NotesTab />
      </TabPanel>
      <TabPanel index="checklists" value={tabValue}>
        <ChecklistTab />
      </TabPanel>
      <TabPanel index="visits" value={tabValue}>
        <VisitsTab visits={visits} />
      </TabPanel>
      <TabPanel index="requestedParts" value={tabValue}>
        <RequestedPartsTab parts={job.preOrderedParts} />
      </TabPanel>
    </>
  );
};
